import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { LoginCard, RequireAuth, useTheme } from "@vimaana/ui";
import AufgabenPage from "./pages/AufgabenPage";
import VertraegePage from "./pages/VertraegePage";
import WizardPage from "./pages/WizardPage";
import VertragDetailPage from "./pages/VertragDetailPage";
import FristenPage from "./pages/FristenPage";
import KundenPage from "./pages/KundenPage";
import KatalogPage from "./pages/KatalogPage";
import BestandPage from "./pages/BestandPage";
import VertragstextPage from "./pages/VertragstextPage";
import AgbPage from "./pages/AgbPage";
import LastschriftPage from "./pages/LastschriftPage";
import EinstellungenPage from "./pages/EinstellungenPage";
import ServerSeite, { SERVER_PFADE } from "./components/ServerSeite";

// Eigener Auth-Scope „pflege" (pflege.vimaanagarten.de). Der Vertrags-Router
// akzeptiert serverseitig pflege- und planer-Sessions (Übergang bis W10).
const APP_NAME = "pflege";

/** Alte Adresse → neue, mit Suchteil (der Qonto-Rückläufer hängt ?qonto=… an). */
function Weiter({ nach }: { nach: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={nach + search + hash} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Vor der Anmeldung: Kunden haben kein Konto. */}
      {SERVER_PFADE.map(p => (
        <Route key={p} path={p + "/*"} element={<ServerSeite />} />
      ))}
      <Route
        path="/*"
        element={
          <RequireAuth appName={APP_NAME}>
            <Routes>
              <Route path="/aufgaben" element={<AufgabenPage />} />
              <Route path="/vertraege" element={<VertraegePage />} />
              <Route path="/vertraege/neu" element={<WizardPage />} />
              <Route path="/vertraege/:id" element={<VertragDetailPage />} />
              <Route path="/kunden" element={<KundenPage />} />
              <Route path="/zahlungen" element={<LastschriftPage />} />
              <Route path="/auswertung" element={<BestandPage />} />
              <Route path="/fristen" element={<FristenPage />} />
              <Route path="/katalog" element={<KatalogPage />} />
              <Route path="/vertragstext" element={<VertragstextPage />} />
              <Route path="/bedingungen" element={<AgbPage />} />
              <Route path="/einstellungen" element={<EinstellungenPage />} />
              {/* Adressen bis 09.10.2026 — Lesezeichen und die installierte App
                  starten noch dort. /lastschrift ist zugleich das Ziel des
                  Qonto-Rückläufers (qonto_oauth.py). */}
              <Route path="/heute" element={<Weiter nach="/aufgaben" />} />
              <Route path="/einsaetze" element={<Weiter nach="/aufgaben" />} />
              <Route path="/interessenten" element={<Navigate to="/kunden?filter=interessent" replace />} />
              <Route path="/bestand" element={<Weiter nach="/auswertung" />} />
              <Route path="/lastschrift" element={<Weiter nach="/einstellungen" />} />
              <Route path="*" element={<Navigate to="/aufgaben" replace />} />
            </Routes>
          </RequireAuth>
        }
      />
    </Routes>
  );
}

/** Anmeldung wie in Kontor: mit Umschalter Hell/Dunkel oben rechts. */
function LoginPage() {
  const { theme, toggleTheme } = useTheme();
  return (
    <div className="kontor-login-theme">
      <button type="button" onClick={toggleTheme}
        aria-label={theme === "dark" ? "Auf helles Design wechseln" : "Auf dunkles Design wechseln"}>
        {theme === "dark" ? "☀ Hell" : "☾ Dunkel"}
      </button>
      <LoginCard appName={APP_NAME} appTitle="Vimaana Pflege" redirectAfterLogin="/aufgaben" />
    </div>
  );
}
